<template>
  <div class="xero-wrap xero-wrap-mobile">
    <div class="logo"></div>
    <div class="clear">
        <div class='back_box' @click="prev">
            <i class="el-icon-back"></i> Back
        </div>
        <div class="pro">
            <div class="tit">2 / 3</div>
            <el-progress :percentage="50"></el-progress>
        </div>
    </div>
    <div class="title">Register Peiso Lite</div>
    <div class="bgd2">
      <div class="con">
        <h1>Opening Times</h1>
        <!-- <h2>Opening Times</h2> -->
        <div class="line" v-for="item in tableData" :key="item.week">
            <div class="clear">
                <div class="tit">{{item.week}}</div>
                <div class="switch">
                    <el-switch
                    v-model="item.value"
                    active-color="#2CCA73"
                    inactive-color="#737983"
                    @change="clearTime($event, item.week, item.pos)">
                    </el-switch>
                </div>
            </div>
            <ul v-if="item.value">
                <li class="clear" v-for="(v, i) in item.timeList" :key="i">
                    <div class="lft"><timeselect @add="receiveTime" :index="i" :week="item.week"></timeselect></div>
                    <div class="rgt">
                        <div class="add" v-if="i == 0" @click="addTime(item.week)">Add</div>
                        <div class="delete" v-if="i != 0" @click="deleteTime(i, item.week)">Delete</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="btm-btns clear">
          <button class="confirm" @click="confirm">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeselect from '../common/timeselect.vue'

export default {
  data () {
    return {
        tableData: [
            {week:'Mon', value: true, timeList:[{time: '09:00 am - 06:00 pm'}], pos: 0},
            {week:'Tues', value: true, value: true, timeList:[{time: '09:00 am - 06:00 pm'}], pos: 1},
            {week:'Wed', value: true, timeList:[{time: '09:00 am - 06:00 pm'}], pos: 2},
            {week:'Thu', value: true, timeList:[{time: '09:00 am - 06:00 pm'}], pos: 3},
            {week:'Fri', value: true, timeList:[{time: '09:00 am - 06:00 pm'}], pos: 4},
            {week:'Sat', value: true, timeList:[{time: '09:00 am - 06:00 pm'}], pos: 5},
            {week:'Sun', value: true, timeList:[{time: '09:00 am - 06:00 pm'}], pos: 6}
        ], 
    }
  },
  created () {
    if (!sessionStorage.getItem('request_params')) {
      this.$router.replace('/register')
    }
  },
  methods: {
      clearTime (e, week, index) {
        this.tableData.splice(index, 1, {
          week:week,
          value: e,
          timeList: e ? [{time: '09:00 am - 06:00 pm'}] : [{time: ''}],
          pos: index
        })
      },
      receiveTime (time, index, week) {
          var that = this
          let currentweek = that.tableData.find(i => {
              return i.week == week
          })
          let temp = JSON.parse(JSON.stringify(currentweek))
          temp.timeList.splice(index, 1, {time: time})
          that.tableData.splice(temp.pos, 1, temp)
      },
      addTime (week) {
          var that = this
          let currentweek = that.tableData.find(i => {
              return i.week == week
          })
          let temp = JSON.parse(JSON.stringify(currentweek))
          temp.timeList.push({time: ''})
          that.tableData.splice(temp.pos, 1, temp)
      },
      deleteTime (index, week) {
          var that = this
          let currentweek = that.tableData.find(i => {
              return i.week == week
          })
          let temp = JSON.parse(JSON.stringify(currentweek))
          temp.timeList.splice(index, 1)
          that.tableData.splice(temp.pos, 1, temp)
      },
      confirm () {
        var that = this
        let venueOpenAddVoList = []
        let complete = true
        that.tableData.forEach(item => {
          let week = ''
          if (item.week == 'Mon')
            week = 'Monday'
          else if (item.week == 'Tues')
            week = 'Tuesday'
          else if (item.week == 'Wed')
            week = 'Wednesday'
          else if (item.week == 'Thu')
            week = 'Thursday'
          else if (item.week == 'Fri')
            week = 'Friday'
          else if (item.week == 'Sat')
            week = 'Saturday'
          else if (item.week == 'Sun')
            week = 'Sunday'
          let openTime = []
          item.timeList.forEach(i => {
            // 正常数据
            if (i.time !== '')
              openTime.push(i.time)
            // 开馆且有时间段没填
            else if (i.time === '' && item.value) {
              complete = false
            }
            // 闭馆
            else if (i.time === '' && !item.value)
              openTime = ''
          })
          if (!complete)
            return
          venueOpenAddVoList.push({
            week: week,
            openTime: openTime === '' ? '' : openTime.join(', ')
          })
        })
        if (!complete) {
          return
        }
        let request_params = JSON.parse(sessionStorage.getItem('request_params'))
        request_params.venueOpenAddVoList = venueOpenAddVoList
        sessionStorage.removeItem('request_params')
        sessionStorage.setItem('request_params', JSON.stringify(request_params))
        // that.$router.replace('/pay')
        that.$router.replace('/mobileApp')
      },
      prev () {
        this.$router.replace('/register')
      }
  },
  components:{
    timeselect
  }
}
</script>

<style lang="scss" scoped>
.xero-wrap{
  color: var(--text-color);
  padding-bottom: 50px;
  min-width: 1200px;
  .bgd2{
    width: 100%;
    background: var(--background-color-4);
    padding: 50px 0 65px 0;
    //margin-bottom: 50px;
    .con{
      width: 750px;
      margin: 0 auto;
      .btm-btns{
        width: 100%;
        margin: 65px auto 0 auto;
        button{
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          float: left;
          box-sizing: border-box;        
          font-size: 26px;
          cursor: pointer;
        }
        .confirm{
          border: 2px solid #EA3796;
          font-weight: 700;
          color: #EA3796;
        }
        .disabled{
          border: 2px solid #8E3771;
          color: #8E3771;
          cursor: not-allowed;
        }
      }
      h1{
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 50px;
      }
      h2{
        font-size: 14px;
        font-family: SFProText-Regular, SFProText;
        font-weight: 400;
        color: var(--text-color);
        line-height: 16px;
        margin-bottom: 40px;
      }
      .line{
        margin-bottom: 30px;
        .tit{
            width: 70px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--text-color);
            line-height: 25px;
            float: left;
        }
        .switch{
            float: left;
            width: 70px;
        }
        li{
            padding-top: 25px;
            .lft{
                float: left;
                width: 620px;
            }
            .rgt{
                float: right;
                .add{
                    width: 98px;
                    height: 50px;
                    background: var(--background-color-4);
                    border: 1px solid #D13A90;
                    line-height: 50px;
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #D13A90;
                    box-sizing: border-box;
                    padding-left: 46px;
                    background-repeat: no-repeat;
                    background-position: 16px 15px;
                    background-size: 20px 20px;
                    background-image: url('../../assets/r.png');
                    cursor: pointer;
                }
                .delete{
                    width: 120px;
                    height: 50px;
                    background: var(--background-color-2);
                    border: 1px solid #5F5F5F;
                    line-height: 50px;
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: var(--text-color);
                    box-sizing: border-box;
                    padding-left: 46px;
                    background-repeat: no-repeat;
                    background-position: 16px 15px;
                    background-size: 20px 20px;
                    background-image: url('../../assets/o.png');
                    cursor: pointer;
                }
            }
        }
      }
    }
  }
}
.pro{
    margin-bottom: 30px;
    width: 200px;
    float: right;
    .tit{
        text-align: right;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #EA3796;
        line-height: 22px;
    }
}
.title{
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: var(--text-color);
    line-height: 33px;
    margin-bottom: 39px;
}
.back_box{
  float: left;
  width: 150px;
  font-size:14px;
  font-weight:600;
  color:var(--text-color);
  line-height:20px;
  cursor: pointer;
  .el-icon-back{
    margin-right: 10px;
    font-size: 20px;
    position: relative;
    top: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register/time.vue